import { render, staticRenderFns } from "./BottomPopup.vue?vue&type=template&id=adaae0d6&scoped=true&"
import script from "./BottomPopup.vue?vue&type=script&lang=ts&"
export * from "./BottomPopup.vue?vue&type=script&lang=ts&"
import style0 from "./BottomPopup.vue?vue&type=style&index=0&id=adaae0d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adaae0d6",
  null
  
)

export default component.exports